<div class="home">
  <div class="body">
    <img src="/assets/images/aser/aser-logo.png" width="300px" height="auto">
    <div class="help-banner">
      <h4>{{'home.questions-1'|translate}}</h4>
      <p>{{'home.questions-2'|translate}}</p>
    </div>
  </div>
</div>
